<template>
  <container-loader v-if="!isDownloadDataLoaded"></container-loader>
  <section v-else class="download-page">
    <div class="top-bar">
      <div class="top-bar--left">
        <b-button @click="tabIndex=0" size="-tab" variant="-gray" :class="{ 'btn--primary': tabIndex === 0 }">Cloud Client</b-button>
        <b-button @click="tabIndex=1" size="-tab" variant="-gray" :class="{ 'btn--primary': tabIndex === 1 }">Plugins</b-button>
        <b-button @click="tabIndex=2" size="-tab" variant="-gray" :class="{ 'btn--primary': tabIndex === 2 }">Ultimaker</b-button>
        <b-button @click="tabIndex=3" size="-tab" variant="-gray" :class="{ 'btn--primary': tabIndex === 3 }">Makerbot</b-button>
      </div>
      <div class="top-bar--right">
      </div>
    </div>

    <b-tabs>

      <b-tab v-if="tabIndex===0" active>
        <b-alert show variant="primary">Organizations please download the STABLE version below. Everyone else, please be reminded that the STABLE version updates only to STABLE, the DEVELOPMENT version only to DEVELOPMENT and BETA to BETA. The STABLE version is updates once per year, DEVELOPMENT once every 1-2 months and the BETA every 1-2 weeks.</b-alert>
        <cloud-client-download-version key="beta"
                                       version-type="beta"
                                       :version-data="downloadData.info.beta">
        </cloud-client-download-version>
        <cloud-client-download-version key="development"
                                       version-type="development"
                                       :version-data="downloadData.info.development">
        </cloud-client-download-version>
        <cloud-client-download-version key="stable"
                                       version-type="stable"
                                       :version-data="downloadData.info.stable">
        </cloud-client-download-version>
      </b-tab>

      <b-tab v-if="tabIndex===1" active>
        <plugins-download :release-notes="downloadData.plugins_release_notes" :plugins-dir="downloadData.plugins_dir"></plugins-download>
      </b-tab>

      <b-tab v-if="tabIndex===2" active>
        <ultimaker-client-installation :cmd="downloadData.u3_cmd"></ultimaker-client-installation>
      </b-tab>

      <b-tab v-if="tabIndex===3" active>
        <makerbot-client-installation></makerbot-client-installation>
      </b-tab>

    </b-tabs>
  </section>
</template>

<script>
  import {mapActions, mapGetters} from "vuex";

  import ContainerLoader from "../components/ContainerLoader";
  import CloudClientDownloadVersion from "../components/download/CloudClientDownloadVersion";
  import PluginsDownload from "../components/download/PluginsDownload";
  import UltimakerClientInstallation from "../components/download/UltimakerClientInstallation";
  import MakerbotClientInstallation from "../components/download/MakerbotClientInstallation";

  export default {
    name: 'download',
    props: {
      tab: {
        type: String
      }
    },
    data() {
      return {
        tabIndex: 0
      }
    },

    created() {
      if (!this.isDownloadDataLoaded) {
        this.fetchDownloadData();
      }
      if (this.tab) {
        switch(this.tab) {
          case 'plugin': this.tabIndex = 1; break;
          case 'u3': this.$nextTick(() => this.tabIndex = 2); break;
          case 'makerbot': this.tabIndex = 3; break;
        }
      }
    },

    components: {
      MakerbotClientInstallation,
      UltimakerClientInstallation,
      PluginsDownload,
      CloudClientDownloadVersion,
      ContainerLoader
    },

    computed: {
      ...mapGetters(['isDownloadDataLoaded', 'downloadData'])
    },

    methods: {
      ...mapActions(['fetchDownloadData'])
    }
  }
</script>

<style lang="scss">
  @import ".././scss/theme";

  .download-page {
    .tabs {
      margin-top: 20px;
    }
  }

  .download-version {
    margin-bottom: 20px;

    .tog {

      &--download-version {
        background-color: $c-primary;
        border-radius: $s-border-radius;
        .top-bar {

          &--left {
            margin-left: 10px;
            font-weight: 600;

            .version-inf {
              text-transform: uppercase;

              svg {
                min-width: 24px;
              }

              .testing-info {
                font-weight: normal;
                text-transform: none;
                margin-left: 10px;
              }
            }
          }

          &--right {
            margin-right: 10px;
          }
        }
      }
    }

    .table--download {
      margin-top: 0;
      padding-bottom: 35px;
      border-top: 0;
      position: relative;
      border-top-left-radius: 0;
      border-top-right-radius: 0;

      .row {
        margin-bottom: 20px;
      }

      .os-version-item {
        text-align: center;

        h4 {
         font-size: 18px;

        }

        .install-link {

          a {
            text-transform: uppercase;
            text-decoration: underline;
            color: $c-red;
            font-size: 18px;

            &:hover {
              text-decoration: none;
            }
          }
        }

        .install-instructions {

          a {
            color: $c-text-gray;
            text-decoration: underline;
          }
        }
      }

      .release-notes-row {
        margin-top: 20px;

        .card-text {
          margin-bottom: 15px;
        }

        .release-notes-less {
          max-height: 150px;
          overflow: hidden;
        }
      }
    }

    .code-block {
      width: 100%;
      background-color: #292929;
      color: #CCCCCC;
      padding: 10px;
      border-radius: 5px;
    }
  }

.alert-primary{
  background-color: lighten($c-primary, 45%);
  border: none;
  color: $f-color;
}
</style>

